import { DspGeoLocation } from '../types/DspGeoLocation';
import { Location } from '../types/Location';

const DspGeoLocationUtils = {
    toLocation: (dspGeoLocation: DspGeoLocation): Location => {
        return {
            id: dspGeoLocation.geoId,
            name: dspGeoLocation.name,
            category: dspGeoLocation.category,
            zipCode: dspGeoLocation.zipcode,
            radius: 30,
        };
    },
};

export default DspGeoLocationUtils;
